import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { environment } from "src/environments/environment";
import { GlobalHttpInterceptor } from "../interceptors/global-http-interceptor";

@Injectable({
	providedIn: "root",
})
export class OrderSocketService {
	initalized: boolean = false;

	socket: WebSocketSubject<any> = webSocket(environment.production ? "wss://ws.focuslink.focuspos.com/" : "wss://dev.ws.focuslink.focuspos.com/");
	socketMessage = new Subject<any>();
	orderStatus = new Subject<string>();

	constructor(private httpInterceptor: GlobalHttpInterceptor) {}

	async connect(venueKey: number, checkKey: string) {
		const licenseKey = environment.licenseKey;
		const licenseSecret = "06fa2be0-7470-4080-a146-4b73d1052866";

		const res = await this.socket.next({
			action: "registerDevice",
			key: licenseKey,
			checkKey: checkKey,
			venueKey: venueKey,
		});
		this.initalized = true;

		this.socket.subscribe((socketMessage) => {
			this.socketMessage.next(socketMessage);
		});
	}

	async disconnect(venueKey: number, checkKey: string) {
		this.socket.next({
			action: "disconnectDevice",
			key: environment.licenseKey,
			checkKey: checkKey,
			venueKey: venueKey,
		});
	}

	public putOrderStatusChange(status: string) {
		console.log(`status change req ${status}`);
		this.orderStatus.next(status);
	}

	public getOrderStatusChange() {
		return this.orderStatus.asObservable();
	}
}
